import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faEye } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { app, auth, db, storage } from "../firebase.config";
import { signInWithEmailAndPassword } from "firebase/auth";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { useNavigate } from "react-router-dom";
const LoginForm = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const Loginuser = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      localStorage.setItem("userid", JSON.stringify(userCredential.user.uid));
      console.log(userCredential.user);
      navigate("/");
      setSuccess("Logged in successfully");
    } catch (error) {
      console.log(error);
      if (error.code === "auth/wrong-password") {
        setError("Wrong password. Please try again.");
      } else if (error.code === "auth/user-not-found") {
        setError("User not found. Please check your email.");
      } else if (error.code === "auth/invalid-credential") {
        setError("Invalid credentials. Please check your email and password.");
      } else if (error.code === "auth/too-many-requests") {
        setError(
          "Access to this account has been temporarily disabled due to many failed login attempts. Please try again later or reset your password."
        );
      } else {
        setError("An error occurred. Please try again later.");
      }
    }
  };
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className="bg-gray-900 text-white min-h-screen flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <header className="flex justify-between items-center mb-8">
            <div className="flex items-center">
              <img src="" alt="" />
              <span className="font-semibold">Metaverse</span>
            </div>
            <nav className="text-gray-400 text-sm">
              <Link to="/" className="mr-4">
                Home
              </Link>
            </nav>
          </header>

          <main>
            <h2 className="text-sm font-semibold text-gray-400 mb-2">
              Welcome Back
            </h2>
            <h1 className="text-4xl font-bold mb-2">
              Log in to your account<span className="text-blue-500">.</span>
            </h1>
            <p className="text-sm text-gray-400 mb-8">
              Not a Member?{" "}
              <Link to="/contact" className="text-blue-500">
                Join Now
              </Link>
            </p>

            <form onSubmit={Loginuser}>
              {error && (
                <div className="bg-red-500 text-white p-3 mb-4 rounded-lg">
                  {error}
                </div>
              )}
              {success && (
                <div className="bg-green-500 text-white p-3 mb-4 rounded-lg">
                  {success}
                </div>
              )}

              <div className="bg-gray-800 rounded-lg p-3 flex items-center mb-4">
                <input
                  type="email"
                  placeholder="Email"
                  className="bg-transparent w-full outline-none focus:font-bold focus:text-white"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <FontAwesomeIcon icon={faUser} className="text-gray-500" />
              </div>

              <div className="bg-gray-800 rounded-lg p-3 flex items-center mb-6">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  className="bg-transparent w-full outline-none focus:font-bold focus:text-white"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <FontAwesomeIcon
                  icon={faEye}
                  className="text-gray-500 cursor-pointer"
                  onClick={togglePasswordVisibility}
                />
              </div>

              <div className="flex justify-between items-center">
                <button
                  type="submit"
                  className="bg-blue-500 text-white px-6 py-2 rounded-lg"
                >
                  Log in
                </button>
              </div>
            </form>
          </main>
        </div>
      </div>
      <Footer />{" "}
    </>
  );
};

export default LoginForm;
